import { Component } from "./component";
import { IPopupComponent } from "../interfaces/iPopupComponent";
import { addCssClass, removeCssClass } from "../utils/dom";

export class PopupComponent extends Component implements IPopupComponent<any> {

  public isPopup(): boolean {
    return true;
  }

  setParentComponent(container: Component) {
    addCssClass(container.getGui(), 'dy-has-popup');
    super.setParentComponent(container);
  }

  public destroy(): void {
    const parentComp = this.parentComponent;
    const hasParent = parentComp && parentComp.isAlive();

    if (hasParent) {
      removeCssClass(parentComp!.getGui(), 'dy-has-popup');
    }

    super.destroy();
  }
}
